'use client';

import { ReactNode } from "react";

export default function Template({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-full animate__animated animate__fadeIn animate__faster">
      {children}
    </div>
  );
}
